import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { TextInput, RadioInputGroup } from '@ztechapps/webui.input'
import { ShowIf } from '@ztechapps/webui.util'
import { useTemplateContext } from './Context'
import { LinkedFilterTemplateFields } from './LinkedFilterTemplateFields'
import { UseAsDefaultSwitch } from './UseAsDefaultSwitch'
import { Col, Row, Stack } from 'react-bootstrap'

export const TemplateFormContent = () => {
  const { components, canSetDefault, canLinkFilterTemplate, filterCategory } = useTemplateContext()

  return (
    <Row className="g-3">
      <Col md={7}>
        <Stack gap={3}>
          <div>
            <Field name="name" component={TextInput} label="Name" />
          </div>

          <div>
            <Field name="description" component={TextInput} label="Description" />
          </div>
        </Stack>
      </Col>

      <Col md={5}>
        <Field
          {...{
            name: 'scope.key',
            label: 'Scope',
            options: [
              {
                label: 'Organization Level, (it will be available for all users of your organization)',
                value: 'tenant',
              },
              { label: 'User Level, (it will be available for you only)', value: 'user' },
            ],
            component: RadioInputGroup,
          }}
        />
      </Col>

      <ShowIf condition={!!canLinkFilterTemplate && !!filterCategory}>
        <Col md={12}>
          <LinkedFilterTemplateFields />
        </Col>
      </ShowIf>

      <ShowIf condition={!!canSetDefault}>
        <Col md={12}>
          <UseAsDefaultSwitch />
        </Col>
      </ShowIf>

      <Col md={12}>
        <components.TemplateInputValue />
      </Col>
    </Row>
  )
}
